

































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { Paciente } from '@/types/_'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage, maskCPFCNPJ, maskDate } from '@/utils/common'
import { useResolverPacienteDuplicado } from '@/composables'

@Component
export default class ComponentModalResolverPacienteDuplicadoBackoffice extends Vue {
  sel: Paciente | null = null
  loadResolver: boolean = false
  modalConfirmaSobrescrita: boolean = false

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get resolverPacienteDuplicado() {
    return useResolverPacienteDuplicado.visible
  }

  get pacientesDuplicados() {
    return useResolverPacienteDuplicado.pacientesDuplicados
  }

  get pacienteHisOriginal() {
    return useResolverPacienteDuplicado.pacienteHisOriginal
  }

  get selected() {
    return this.sel
  }

  set selected(value: Paciente | null) {
    this.sel = value
  }

  get pacienteSelecionado() {
    return this.sel && this.sel.id
  }

  get loadingResolver() {
    return this.loadResolver
  }

  set loadingResolver(value: boolean) {
    this.loadResolver = value
  }

  get camposQueVaoMudar() {
    if (!this.sel || !this.pacienteHisOriginal) return []
    const his = this.pacienteHisOriginal
    const campos: { campo: string; antes: string; depois: string }[] = []
    if (this.sel.nome !== his.nome) {
      campos.push({ campo: 'Nome', antes: this.sel.nome || '—', depois: his.nome || '—' })
    }

    if (this.sel.cpf !== his.cpf) {
      campos.push({ campo: 'CPF', antes: this.formatCpf(this.sel.cpf), depois: this.formatCpf(his.cpf) })
    }

    if (this.formatData(this.sel.dataNascimento) !== this.formatData(his.dataNascimento)) {
      campos.push({ campo: 'Data de Nascimento', antes: this.formatData(this.sel.dataNascimento), depois: this.formatData(his.dataNascimento) })
    }

    if (this.sel.hisId !== his.hisId) {
      campos.push({ campo: 'HIS ID', antes: this.sel.hisId || '—', depois: his.hisId || '—' })
    }

    return campos
  }

  colunas: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'CPF', value: 'cpf', sortable: false },
    { text: 'Data de nascimento', value: 'dataNascimento', sortable: false },
    { text: 'HIS ID', value: 'hisId', sortable: false },
  ]

  formatCpf(cpf: string) {
    return maskCPFCNPJ(cpf)
  }

  formatData(value: string) {
    return maskDate(value)
  }

  fechar() {
    this.sel = null
    this.modalConfirmaSobrescrita = false
    useResolverPacienteDuplicado.fechar()
  }

  resolverDuplicata() {
    if (!this.pacienteSelecionado) return
    if (this.pacienteHisOriginal && this.camposQueVaoMudar.length > 0) {
      this.modalConfirmaSobrescrita = true
      return
    }
    this.executarResolverDuplicata()
  }

  cancelarSobrescrita() {
    this.modalConfirmaSobrescrita = false
  }

  async executarResolverDuplicata() {
    if (!this.sel) return
    const selecionado = this.sel

    this.modalConfirmaSobrescrita = false
    this.loadingResolver = true

    const idsPacienteDuplicado = this.pacientesDuplicados
      .filter(p => p.id !== selecionado.id)
      .map(p => p.id)

    const response = await useResolverPacienteDuplicado.resolver({
      idPacienteMantido: selecionado.id,
      idsPacienteDuplicado,
    })

    if (response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage('Duplicata resolvida com sucesso!', 'success'))
      this.getBackofficeGlobalStore.getSolicitacaoById(useResolverPacienteDuplicado.solicitacaoId)
      this.fechar()
    } else {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Não foi possível resolver a duplicata', 'error'))
    }

    this.loadingResolver = false
  }
}
